import { isEmpty } from 'underscore';

export default {
  run(em, sender, opts = {}) {
    if (opts && opts.sender) {
      sender = opts.sender;
    }
    let command = opts.command;
    switch (command) {
      case 'recordState':
        $('#gjs').addClass('restrict');
        let sel = em.getSelected();
        let className = sender.get('className');
        if (sel) {
          let cssc = em.CssComposer;
          em.$('#gjs-clm-new')
            .val(className)
            .trigger('keyup', 13); // adds class to current selected component.
          var idRule = cssc.getRule(`.${className}#${sel.getId()}`);
          var style = idRule ? idRule.get('style') : {};
          var classArr = sel.getClassesForStates();
          cssc.getClassRule(classArr).set('style', style);
          sel.set('isStateRecording', true);
          sel.set('recordingStateName', className);
        }
        break;
      default:
        break;
    }
  },
  stop(em, sender, opts) {
    if (opts && opts.sender) {
      sender = opts.sender;
    }
    var command = opts.command;
    switch (command) {
      case 'recordState':
        $('#gjs').removeClass('restrict');
        let sel = em.getSelected();
        let className = sender.get('className');
        let isRecording = sel && sel.get('isStateRecording');
        if (isRecording) {
          let sm = em.SelectorManager;
          let cssc = em.CssComposer;
          let states = sel.get('customStates');
          let recordedState = sel.get('recordedState');
          var classArr = sel.getClassesForStates();
          cssc.getAll().remove(cssc.getClassRule(classArr)); // removes css.
          sel.getSelectors().remove(sm.get(className)); // removes class from component.
          if (
            em.Config.blockWithStates.indexOf(sel.getId()) === -1 &&
            !isEmpty(recordedState)
          ) {
            em.Config.blockWithStates.push(sel.getId());
          }
          states = {
            ...states,
            ...recordedState
          };
          sel.set('customStates', states);
          sel.resetCustomState();
          sel.setCssRule(sel.get('customStates'));
        }
        break;
      default:
        break;
    }
  }
};
